// extracted by mini-css-extract-plugin
module.exports = {"btnGreen":"styles_btnGreen__3vfk_","btnRed":"styles_btnRed__1DE9h","message":"styles_message__3l2ye"};